export const enumCompetenceType = {
    DEBASE : 0,
    SPECIFIQUE : 1,
}